import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

const App = (props) => {
  return (
    <div className={props.class}>
      <HelmetProvider>
        <Helmet>
          <script
            src="https://cdn.pinpayments.com/pin.hosted_fields.v1.js"
            type="text/javascript"
          ></script>
        </Helmet>
      </HelmetProvider>

      {props.children[0]}
      <main>
        <section className="relative block bg-gray-100 xs:p-0">
          <div className="md:container sm:px-4 sm:pt-4 sm:pb-24 xs:m-auto xs:p-0 xs:pt-0 min-h-[80vh]">
            {props.children[1]}
          </div>
        </section>
      </main>
      {props.children[2]}
    </div>
  );
};

const Tight = (props) => {
  return (
    <div className={props.class}>
      <div>
        <div className="flex flex-wrap justify-center">
          <div className="lg:w-6/12 xs:w-screen sm:px-4 xs:p-0 ">
            <div
              className="relative flex flex-col min-w-0 break-words sm:w-full xs:m-0 sm:min-h-[82%] 
            xs:min-h-screen xs:w-screen xs:rounded-none xs:shadow-none sm:mb-6 sm:mt-20 sm:shadow-lg bg-white sm:rounded-lg"
            >
              <div className="flex-auto md:container xs:p-5 sm:p-5 lg:p-10 m-auto xs:w-full">
                {props.children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const layout = { App, Tight };

export default layout;
